import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { MessageCircle } from "lucide-react";

export default function AdminNotifications() {
  const [items, setItems] = useState([]);
  useEffect(()=>{ api.get("/notifications").then(r=>setItems(r.data)).catch(()=>{}); }, []);
  return (
    <div>
      <h1 className="text-3xl font-display font-black tracking-tight">WhatsApp Notifications <span className="text-sm font-normal text-slate-500">(mocked)</span></h1>
      <p className="text-sm text-slate-500 mt-2">These messages would be delivered via WhatsApp Business API in production.</p>
      <div className="mt-6 space-y-3">
        {items.map(n => (
          <div key={n.id} className="p-4 rounded-xl bg-white border border-slate-200 flex items-start gap-3" data-testid={`notif-${n.id}`}>
            <div className={`w-10 h-10 rounded-full grid place-items-center ${n.target==="admin"?"bg-[#1e1b4b] text-white":"bg-emerald-500 text-white"}`}>
              <MessageCircle className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <div className="text-xs uppercase tracking-widest text-slate-500">{n.target} · {n.kind.replace(/_/g,' ')}</div>
              <div className="mt-1 text-sm">{n.message}</div>
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.sent_at).toLocaleString()} {n.booking_id && `· ${n.booking_id}`}</div>
            </div>
          </div>
        ))}
        {items.length===0 && <div className="p-6 rounded-xl bg-white border border-slate-200 text-sm text-slate-500">No notifications yet.</div>}
      </div>
    </div>
  );
}
